module.exports = __webpack_public_path__ + "static/amare_img_25_h-140b6f0a410ded7c8d798831634faf68.jpg";